import { render, staticRenderFns } from "./AssessmentTemplateCard.vue?vue&type=template&id=e3d4562c&scoped=true&"
import script from "./AssessmentTemplateCard.vue?vue&type=script&lang=ts&"
export * from "./AssessmentTemplateCard.vue?vue&type=script&lang=ts&"
import style0 from "../theme/plugins/themify-icons/themify-icons.css?vue&type=style&index=0&id=e3d4562c&prod&scoped=true&lang=css&"
import style1 from "./AssessmentTemplateCard.vue?vue&type=style&index=1&id=e3d4562c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d4562c",
  null
  
)

export default component.exports